import { render } from "./PanelEditor.vue?vue&type=template&id=913cf192&scoped=true&ts=true"
import script from "./PanelEditor.vue?vue&type=script&lang=ts"
export * from "./PanelEditor.vue?vue&type=script&lang=ts"

import "./PanelEditor.vue?vue&type=style&index=0&id=913cf192&scoped=true&lang=css"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-913cf192"]])

export default __exports__